<template>
  <div class="main">
    <a-card :bordered="false" class="cate-lists">
      <div class="main-table">
        <div style="margin-bottom:10px">
          <!-- <a-form-model-item>
            <a-select
              style="width: 200px"
              :value="roleValue"
              @change="handleChange"
            >
              <a-select-option v-for="item in rolelist" :key="item.id">
                {{ item.rolename }}
              </a-select-option>
            </a-select>
            <a-button
              type="primary"
              style="margin-left:20px"
              @click="userupdate"
              >修改用户组</a-button
            >
          </a-form-model-item> -->
        </div>
        <a-table
          :columns="columns"
          :dataSource="userlist"
          :pagination="false"
          :rowKey="record => record.id"
          size="small"
          :loading="loading"
        >
          <a slot="truename" slot-scope="text">{{ text }}</a>
          <template slot="rolename" slot-scope="text, record, index">
            <a-select
              style="width: 200px"
              :value="record.role_id"
              @change="value => handleChange(value, record.id, index)"
              :disabled="record.role_id < myrole_id"
            >
              <a-select-option
                v-for="item in rolelist"
                :key="item.id"
                :disabled="item.id < myrole_id"
              >
                {{ item.rolename }}
              </a-select-option>
            </a-select>
          </template>
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
const columns = [
  {
    title: '用户ID',
    dataIndex: 'id',
    width: 150,
    scopedSlots: { customRender: 'id' },
    align: 'center'
  },
  {
    title: '账号名称',
    dataIndex: 'truename',
    scopedSlots: { customRender: 'truename' }
  },

  {
    title: '权限等级',
    dataIndex: 'rolename',
    width: 200,
    scopedSlots: { customRender: 'rolename' },
    align: 'center'
  },

  {
    title: '最后登录时间',
    dataIndex: 'lasttime',
    scopedSlots: { customRender: 'lasttime' },
    align: 'center'
  }
];
export default {
  data() {
    return {
      columns,
      userlist: [],
      rolelist: [],
      myrole_id: 0,
      loading: true
    };
  },
  watch: {},
  methods: {
    getRolelist() {
      //获取用户组
      this.$http
        .post('/api/ucenter/rolelist', { page: 1, limit: 999 })
        .then(res => {
          if (res.data.state == 200) {
            res.data.data.forEach(element => {
              if (element.type != -1) {
                this.rolelist.push(element);
              }
            });
          }
        });
    },
    getUserlit() {
      this.$http.post('/api/ucenter/userlist', { limit: 9999 }).then(res => {
        if (res.data.state == 200) {
          this.userlist = res.data.data;
        }
      });
      this.loading = false;
    },
    handleChange(value, id, index) {
      const newData = [...this.userlist];
      newData[index].role_id = value;
      this.userlist = newData;
      this.userupdate(id, value);
    },
    userupdate(id, role_id) {
      this.$http
        .post('/api/ucenter/userRoleUpdate', { id, role_id })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('修改成功');
            this.loading = true;
            this.getUserlit();
          } else {
            this.$message.error('修改失败');
          }
        });
    }
  },
  created() {
    if (localStorage.getItem('siteinfo')) {
      this.myrole_id = JSON.parse(localStorage.getItem('siteinfo')).role_id; //无法更高用户权限高于自己的用户
    } else {
      this.myrole_id = 100;
    }
  },
  mounted() {
    this.getRolelist();
    this.getUserlit();
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
.cate-lists {
  /* width: 710px; */
  margin: 0 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.main-table {
  padding: 10px;
}
</style>
